import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { PrivateRoute } from '../components/PrivateRoute';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { SignInScene } from '../scenes/SignInScene';
import { ResetPasswordRequestScene } from '../scenes/ResetPasswordRequestScene';
import { ResetPasswordScene } from '../scenes/ResetPasswordScene';
import { ProjectsScene } from '../scenes/ProjectsScene';
import { UsersScene } from '../scenes/UsersScene';
import { BuildingsScene } from '../scenes/BuildingsScene';
import { WorkstationsScene } from '../scenes/WorkstationsScene';
import { ProjectCreateScene } from '../scenes/ProjectCreateScene';
import { ProjectDetailScene } from '../scenes/ProjectDetailScene';
import { PtwCreateScene } from '../scenes/PtwCreateScene';
import { PtwDetailScene } from '../scenes/PtwDetailScene';
import { EhssScene } from '../scenes/EhssScene';
import { EhsCreateScene } from '../scenes/EhsCreateScene';
import { EhsViewScene } from '../scenes/EhsViewScene';

const routes = (
  <React.Fragment>
    {/*<NavBar />*/}
    <Switch>
      <Route exact path="/">
        <Redirect to={{ pathname: '/projects' }} />
      </Route>
      <Route exact path="/signin" component={SignInScene} />
      {/*<Route exact path="/signup" component={SignUpComponent} />*/}
      <Route exact path="/reset-password" component={ResetPasswordRequestScene} />
      <Route exact path="/reset-password/:token" component={ResetPasswordScene} />
      <PrivateRoute exact path="/projects" component={ProjectsScene} />
      <ProtectedRoute exact path="/projects/create" component={ProjectCreateScene} />
      <PrivateRoute exact path="/projects/:projectId" component={ProjectDetailScene} />
      <PrivateRoute exact path="/projects/:projectId/create" component={PtwCreateScene} />
      <PrivateRoute exact path="/projects/:projectId/:ptwId" component={PtwDetailScene} />
      <PrivateRoute exact path="/ehss" component={EhssScene} />
      <PrivateRoute exact path="/ehss/create" component={EhsCreateScene} />
      <PrivateRoute exact path="/ehss/view/:ehsId" component={EhsViewScene} />
      <ProtectedRoute exact path="/users" component={UsersScene} />
      <ProtectedRoute exact path="/workstations" component={WorkstationsScene} />
      <ProtectedRoute exact path="/buildings" component={BuildingsScene} />
      <Route render={() => <Redirect to={{ pathname: '/projects' }} />} />
    </Switch>
  </React.Fragment>
);

export default routes;
